import { SearchResultsListingsGridQuery_searchResults_SearchResults_listings_LeasingListing_trackingContext_TrackingContext_advertCardFeatures_TrackingAdvertCardFeatures } from '../../contexts/search-results-context/query/__generated__/search-results-listings.fed.query'
import { AdvertCardFeatures100 } from '@at/track-types'

export const advertCardFeatures = (
    advertCardFeatures: SearchResultsListingsGridQuery_searchResults_SearchResults_listings_LeasingListing_trackingContext_TrackingContext_advertCardFeatures_TrackingAdvertCardFeatures
): AdvertCardFeatures100 => {
    return {
        SCHEMA_KEY: 'AdvertCardFeatures100',
        condition: advertCardFeatures.condition || undefined,
        num_images: advertCardFeatures.numImages,
        has_finance: advertCardFeatures.hasFinance,
        price_indicator: advertCardFeatures.priceIndicator || undefined,
        is_manufactured_approved: advertCardFeatures.isManufacturedApproved,
        is_franchise_approved: advertCardFeatures.isFranchiseApproved,
    }
}
